export const COMPONENT_LOCATOR = 'SurveyScript';